import React, { useState } from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'

type SearchProps = {
  newsletters: any
  setDataFilter: (data: any) => void
  search: string
  setSearch: (data: any) => void
  resetFilters: () => void
}
export const Search = ({
  newsletters,
  setDataFilter,
  search,
  setSearch,
  resetFilters,
}: SearchProps) => {
  const handleSearch = e => {
    resetFilters()
    const value = e.target.value
    setSearch(value)
    const filteredList = []
    newsletters.map(year => {
      year.months.map(month => {
        month.newsletters.map(newsletter => {
          if (newsletter.title.toLowerCase().includes(value.toLowerCase())) {
            if (!filteredList[year.year]) filteredList[year.year] = {}
            if (!filteredList[year.year][month.month])
              filteredList[year.year][month.month] = []
            filteredList[year.year][month.month].push(newsletter)
          }
        })
      })
    })

    const data = Object.entries(filteredList)
      .map(([year, months]) => ({
        year,
        months: Object.entries(months).map(([month, newsletters]) => ({
          month,
          newsletters,
        })),
      }))
      .reverse()

    setDataFilter(data)
  }

  return (
    <div className={styles.inputContainer}>
      {search === '' ? (
        <Image
          src='/assets/icons/icon-search-grey.svg'
          width='15'
          height='15'
          alt='search icon'
        />
      ) : (
        <Image
          src='/assets/icons/icon-close-green.svg'
          width='14'
          height='14'
          alt='close icon'
          onClick={() => setSearch('')}
        />
      )}
      <input
        className={styles.input}
        type={'text'}
        value={search}
        onChange={handleSearch}
        placeholder={'Search newsletter'}
      />
    </div>
  )
}
